import React from 'react';
import UninvoicedBonlivCard from '../components/dashboard/UninvoicedBonlivCard';
import { Row, Col, Typography } from 'antd';
import { DashboardOutlined } from '@ant-design/icons';

const { Title } = Typography;

const DashboardPage = () => {
  return (
    <div style={{ 
      padding: '24px',
      background: 'linear-gradient(180deg, #f5f7fa 0%, #e8ecf1 100%)',
      minHeight: 'calc(100vh - 64px)'
    }}>
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 12 }}>
          <DashboardOutlined style={{ color: '#1890ff' }} />
          Tableau de Bord - Insights Business
        </Title>
        <p style={{ color: '#666', marginTop: 8, marginBottom: 0 }}>
          Surveillez les indicateurs clés de votre activité
        </p>
      </div>

      {/* Main Content */}
      <Row gutter={[24, 24]}>
        {/* Uninvoiced Bonliv - Full Width for now */}
        <Col span={24}>
          <UninvoicedBonlivCard />
        </Col>
      </Row>
    </div>
  );
};

export default DashboardPage;
